export default __webpack_public_path__ + "static/media/baby-9.15e5234d.svg";